<template>
</template>

<script>
export default {
  name: 'search',
  computed: {
  },
  components: {
  }
}
</script>

<!--<style src="@/assets/scss/main/index.scss" lang="scss" scoped/>-->



// WEBPACK FOOTER //
// Search.vue?7018fdd2